module.exports = __webpack_public_path__ + "static/media/logo_red.904bc8f0.png";